import { Button, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { CreateDeviceTemplateWizardWrapper, FormWrapper, OperationWrapper, Title, TitleWrapper } from "./CreateGatewayWizard.styled";
import ProductApi from "../../../../api/ProductApi";
import DeviceTemplateApi from "../../../../api/DeviceTemplateApi";
import GatewayApi from "../../../../api/GatewayApi";

interface CreateGatewayWizardProps {
    onClose: ()=> void,
    onComplete: ()=> void,
}

export const CreateGatewayWizard: React.FC<CreateGatewayWizardProps> = (props)=> {
    // api
    let gatewayApi = new GatewayApi();
    let productApi = new ProductApi();
    const [form] = Form.useForm();

    // state
    let [submitEnabled, setSubmitEnabled] = useState(false);
    let [createGatewayParams, setCreateGatewayParams] = useState({});

    // validate
    let validateForm = ()=> {
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            console.log(err);
        });
    }

    // events
    
    let onGatewaySnChange = (e)=> {
        createGatewayParams.sn = e.target.value;
        validateForm();
    };

    let onGatewayNameChange = (e)=> {
        createGatewayParams.name = e.target.value;
        validateForm();
    };

    let onGatewayNoChange = (e)=> {
        createGatewayParams.no = e.target.value;
        validateForm();
    };

    let onRemarksChange = (e)=> {
        createGatewayParams.remarks = e.target.value;
        validateForm();
    };

    let onSubmit = async (e)=> {
        if (createGatewayParams.id) {
            await gatewayApi.update(createGatewayParams);
        } else {
            await gatewayApi.create(createGatewayParams);
        }
        props.onComplete();
        props.onClose();
    };

    let onCancel = (e)=> {
        props.onClose();
    };

    // render
    return (
        <CreateDeviceTemplateWizardWrapper>
            <TitleWrapper>
                <Title>新增网关</Title>
            </TitleWrapper>

            <FormWrapper>
                <Form form={form} name="form" layout="vertical">
                    <Form.Item name="name" label="网关序列号SN" rules={[{required: true}]} initialValue={createGatewayParams.sn}>
                        <Input onChange={onGatewaySnChange} />
                    </Form.Item>

                    <Form.Item name="name" label="网关名称" rules={[{required: true}]} initialValue={createGatewayParams.name}>
                        <Input onChange={onGatewayNameChange} />
                    </Form.Item>

                    <Form.Item name="name" label="网关编号" rules={[{required: true}]} initialValue={createGatewayParams.no}>
                        <Input onChange={onGatewayNoChange} />
                    </Form.Item>

                    <Form.Item name="remarks" label="备注" rules={[{required: false}]} initialValue={createGatewayParams.remarks}>
                        <Input.TextArea style={{height: '100px'}} onChange={onRemarksChange}/>
                    </Form.Item>
                </Form>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </CreateDeviceTemplateWizardWrapper>
    )
}
